import React from 'react';
import { ISelectedDriver } from '@types';

interface DriverInfoProps {
  driversSelected?: ISelectedDriver[];
}

const DriverInfo: React.FC<DriverInfoProps> = ({
  driversSelected = []
}) => {
  if (driversSelected.length === 0) return null;

  if (driversSelected.length === 1) {
    const driver = driversSelected[0];
    return (
      <div className="display-flex align-items-center gap-10">
        <div
          className="width-30 height-30 rounded-circle aspect-ratio-1 bg-size-100pct bg-repeat-no bg-light"
          style={{
            backgroundImage: `url(${driver.avatar || "https://cdn.rio.cloud/svg/common/ico_rio_colored.svg"})`,
          }}
        />
        <div>
          <span className="text-size-16 text-normal line-height-20 text-capitalize">
            {driver.name}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="display-flex align-items-center gap-10">
      <span className="text-size-16 text-normal line-height-20">
        {driversSelected.length} motoristas selecionados
      </span>
    </div>
  );
};

export default DriverInfo;